import { SvgIcon } from '@mui/material';
import classNames from 'classnames';
import { memo, PropsWithChildren } from 'react';
import css from './SvgIcon.module.scss';

interface ComponentProps extends PropsWithChildren {
    /**
     * Determines the color of the icon. Default 'dark'
     *
     * light - lightTextColor
     * dark - mainTextColor
     */
    color?: 'light' | 'dark';
    /**
     * Applies disabled styling (disabledTextColor)
     */
    disabled?: boolean;
}

export const GMSvgIcon: React.FC<ComponentProps> = memo(({ disabled, color = 'dark', children }) => {
    return (
        <SvgIcon className={classNames({
            [css.dark]: color === 'dark',
            [css.light]: color === 'light',
            [css.disabled]: !!disabled,
        })}
        >
            {children}
        </SvgIcon>
    );
});